import { render, staticRenderFns } from "./EditorLink.vue?vue&type=template&id=73e8f49a&scoped=true&"
import script from "./EditorLink.vue?vue&type=script&lang=js&"
export * from "./EditorLink.vue?vue&type=script&lang=js&"
import style0 from "./EditorLink.vue?vue&type=style&index=0&id=73e8f49a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e8f49a",
  null
  
)

export default component.exports